import React, { Component } from "react";
import "../css/SgCampaign.css";
// import whatsappIcon from "../images/whatsapp.svg";
// import { Dropdown } from "semantic-ui-react";
import "react-select/dist/react-select.css";
import "react-virtualized/styles.css";
import "react-virtualized-select/styles.css";
import VirtualizedSelect from "react-virtualized-select";
import IndiaImg from "../images/IndiaImg.svg";


import VideoModal from './videoModal'

class Forms extends Component {
  constructor() {
    super();
    this.state = {
      Name: "",
      MobileNumber: "",
      City: "",
      Email: "",
      EmailValidation: true,
      Identity: "",
      utm_source: "",
      utm_medium: "",
      utm_campaign: "",
      success: false,
      countryOptions: [],
      isChecked: true,
      showVideoModal: false
    };
  }

  toggleVideoModal = () =>{
    this.setState({
      showVideoModal: !this.state.showVideoModal
    })
  }

  componentDidMount = () => {
    const vars = {};
    const parts = window.location.href.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      function (m, key, value) {
        vars[key] = value;
      }
    );
    // this.handleCityApi();
    this.handleStateApi();
    this.setState({
      utm_source: vars["utm_source"],
      utm_medium: vars["utm_medium"],
      utm_campaign: vars["utm_campaign"],
    });
  };

  parseAPIData = (data) => {
    let options = data.map((el) => ({
      key: el.id,
      text: el.city,
      value: el.id,
    }));
    // console.log('options', options);
    return options;
  };


  handleStateApi = () =>{
    fetch(
      //'http://sales-incentive.classplus.co/newapi/saveonlineleads.php',
      "https://crm.classplus.co/su/affiliate/state?state=1", // for city data use =>  "/state?city=1"
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        // body: JSON.stringify(payload)
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        let countries = data.data.states;
        // console.log(countries,"sss")
        let countryOptions = countries.map((obj,ind) => {
          return {
            key: ind,
            label: obj,
            // value: obj.value,
          };
        });
        // console.log(countryOptions,"PPP")
        this.setState({ countryOptions: countryOptions });
      })
      .catch((err) => alert("Please Enter Valid Details"));
  };
  

  // handleCityApi = () => {
  //   fetch(
  //     //'http://sales-incentive.classplus.co/newapi/saveonlineleads.php',
  //     "https://crm.classplus.co/su/affiliate/state?city=1",
  //     {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       // body: JSON.stringify(payload)
  //     }
  //   )
  //     .then((res) => {
  //       return res.json();
  //     })
  //     .then((data) => {
  //       let countries = this.parseAPIData(data.data.city);
  //       let countryOptions = countries.map((obj) => {
  //         return {
  //           key: obj.key,
  //           label: obj.text,
  //           value: obj.value,
  //         };
  //       });
  //       this.setState({ countryOptions: countryOptions });
  //     })
  //     .catch((err) => alert("Please Enter Valid Details"));
  // };

  nameChange = (e) => {
    this.setState({
      Name: e.target.value,
    });
  };

  mobileChange = (e) => {
    const re = /^[0-9\b]+$/;

    if (e.target.value === "" || re.test(e.target.value)) {
      if (e.target.value.length <= 10) {
        this.setState({
          MobileNumber: e.target.value,
        });
      }
    }
  };

  emailChange = (e) => {
    const emialvalid = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    if (e.target.value === "" || emialvalid.test(e.target.value)) {
      this.setState({
        Email: e.target.value,
        EmailValidation: true,
      });
    } else {
      this.setState({
        Email: e.target.value,
        EmailValidation: false,
      });
    }
  };
  // city is putted in email. As per api demand.

  // cityChange = (e, data) => {
  //     let selectedCity = this.state.countryOptions.filter((country) => {
  //         return country.value === data.value;
  //     })[0];
  //     this.setState({
  //         City: selectedCity
  //     });
  // };

  identityChange = (e) => {
    this.setState({
      Identity: e.target.value,
    });
  };

  handleCheck = () => {
    this.setState({
      isChecked: !this.state.isChecked,
    });
  };

  formData = (e) => {
    e.preventDefault();
    if (this.state.MobileNumber.length < 10) {
      alert("Please Enter valid 10 digit mobile number");
    }

    if (this.state.Name == "") {
      alert("Please enter your name");
      return
    }

    if (this.state.City == "") {
      alert("Please enter your city");
      return
    }

    if (this.state.EmailValidation === false) {
      alert("Please enter valid Email");
      return
    }

    if (this.state.Identity.length === 0) {
      alert("Please select your profession");
      return
    } 



      const body = { ...this.state, appointmentDate: "" };
      // console.log("body",body);
      // fetch('https://hooks.zapier.com/hooks/catch/4460305/vr6ciu/', {
      //     method: 'POST',
      //     headers: {
      //         // "Content-Type": 'application/json',
      //     },
      //     body: JSON.stringify(body),
      // }).then(
      //     //  res => console.log(res, 'palash reesp')

      //     this.successPopUp(),
      //     this.clearFormData()

      // )
      //     .catch(err => alert("Please Enter Valid Details")
      //     );

      let payload = {
        type: "sg_campaign",
        coachingName: this.state.Name,
        city: this.state.City.label,
        state: this.state.City.label,
        email: this.state.EmailValidation ? this.state.Email : "",
        mobileNumber: this.state.MobileNumber,
        campaignName: this.state.utm_campaign,
        utmSource: this.state.utm_source,
        isOptIn: this.state.isChecked ? 1 : 0,
      };
      fetch(
        //  'http://sales-incentive.classplus.co/newapi/saveonlineleads.php',
        "https://crm.classplus.co/su/website",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      )
        .then(
          //  res => console.log(res, 'palash reesp')

          this.successPopUp(),
          this.clearFormData(),
          setTimeout(() => {
            this.toggleVideoModal()
          }, 500)
        )
        .catch((err) => alert("Please Enter Valid Details"));
    
  };

  successPopUp = () => {
    this.setState(
      {
        success: true,
      },
      () => {
        localStorage.setItem("classplusFormSubmitted", true);
      }
    );
  };

  clearFormData = () => {
    this.setState(
      {
        Name: "",
        MobileNumber: "",
        City: "",
        Identity: "",
        Email: "",
      },
      () => {
        window.gtag("event", "conversion", {
          send_to: "AW-825420150/DJosCP2HrXoQ9tLLiQM",
        });
        window.gtag("event", "submit", {
          event_category: "form",
          event_label: "book demo",
        });
      }
    );
  };

  // clearPopup = () => {
  //     //alert("Success");
  //     console.log("Success3")
  //     console.log(this.state.success, "Success3")
  //     this.setState({
  //         success: false
  //     })
  //     console.log(this.state.success,"Success4")
  // }
  render() {
    // return ''

    return (
      <div style={{ width: "100%" }}>
        {this.state.success == true ? (
          <div className="successPopup successOut">
            <div className="successPopup__content">
              We have registered your response successfully and will get back to
              you soon Thank you!
            </div>
          </div>
        ) : (
          <div />
        )}
        <form className="form">
          <input
            type="text"
            className="form__input"
            placeholder="Your Institute's Name *"
            required
            onChange={this.nameChange}
            value={this.state.Name}
          />
          <div className="form__input-mobile">
            <div className="form__input-mobile-image">
              <img src={IndiaImg} alt="" />
            </div>
            <input
              type="text"
              className="form__input-m"
              placeholder="Your Mobile Number *"
              required
              onChange={this.mobileChange}
              value={this.state.MobileNumber}
            />
          </div>
          <input
            type="email"
            className="form__input"
            placeholder="Your Email"
            onChange={this.emailChange}
            value={this.state.Email}
          />
          <div className="FormDropdownContainer">
            {/* <input type="text" className="form__input form__input--2" placeholder="Your city *" required onChange={this.cityChange} value={this.state.City}/> */}
            {/*<Dropdown
                                style={{ border: '1px solid #979797' }}
                                className="form__input form__input--2"
                                placeholder="Your city *"
                                fluid
                                search
                                selection
                                options={this.state.countryOptions}
                                onChange={this.cityChange}
                                value={Object.keys(this.state.City).length ? this.state.City.key : ''}
                            />*/}
            <VirtualizedSelect
              className="cityDropdown"
              style={{ border: "none", marginTop: "4px" }}
              placeholder="Your state *"
              clearable={false}
              maxHeight={150}
              options={this.state.countryOptions}
              onChange={(City) => this.setState({ City })}
              value={this.state.City}
            />

            <select
              className="select-css"
              required
              onChange={this.identityChange}
              value={this.state.Identity}
            >
              <option value="" disabled defaultValue>
                Who are you? *
              </option>
              <option value="Tutor">Tutor</option>
              <option value="Student">Student</option>
              <option value="Parent">Parent</option>
            </select>
          </div>

          {/*<label>
                        <input type="checkbox" defaultChecked="checked" checked={this.state.isChecked} onChange={this.handleCheck} ></input>
                        <span className="checkmark">I agree to receive messages and notifications on whatsapp</span>
                    </label>*/}

          <button
            type="submit"
            className="form__button"
            style={{ marginBottom: "8px",}}
            onClick={this.formData}
          >
            Book a Free Demo
          </button>
          {this.state.showVideoModal && <VideoModal toggleVideo={this.toggleVideoModal} embedLink="wmgGv6TrJcs"/>}
           
          {window.screen.width > 700 ? (
              " "
            ) : ( 
          <div style={{ borderBottom: '1px dashed #E5E5E5' }}></div>)}

          {window.screen.width > 700 ? (
              " "
            ) : (
          <a href='tel:9090404009'>
            <button
            type="button"
            className="form__button2"
            style={{ marginBottom: "16px", backgroundColor: "#00FF00" }}
          >
            Call us directly on 9090404009
          </button>
          </a>)}
          
          {
            //   window.innerWidth < 480 && this.props.source =="contact" ?
            //   <div>
            //   <hr></hr>
            // <div className="whatsappBtn form__button btn btn--bookADemo">
            //         <a href="https://api.whatsapp.com/send?phone=917290085264&text=Hi Classplus, I would like to know more about your Complete Coaching Solution" target="_blank" className="whatsappAnchor">
            //             <img alt="" src={whatsappIcon} style={{ height: "20px", width: "20px" }} />
            //             <p style={{paddingLeft:"8px"}}> Talk to us immediately </p>
            //         </a>
            // </div>
            // </div>
            // :""
          }
        </form>
      </div>
    );
  }
}

export default Forms;
